// Shared Quill font configuration for every rich-text editor in the app.
// Keep the whitelist in sync with src/css/QuillFonts.css,
// public-bluebird-documentation/src/app/globals.css (the public site renders
// the same ql-font-* classes) and the PDF export in the backend:
// bluebird-user-documentation/documentation/static/pdf/document.css plus the
// FONT_FACES table in documentation/pdf_export.py, which bundles the font files.
import { Quill } from "react-quill-new";

export const FONT_WHITELIST = [
  "arial",
  "georgia",
  "times-new-roman",
  "monospace",
  "merriweather",
  "caveat",
];

const FontAttributor = Quill.import("attributors/class/font");
FontAttributor.whitelist = FONT_WHITELIST;
Quill.register(FontAttributor, true);

// Toolbar dropdown entry; `false` is the "Default" (Poppins) option.
export const FONT_TOOLBAR_ENTRY = { font: [false, ...FONT_WHITELIST] };
